import { URLS } from '../../../constants';
import apiClient from '../../client';

const getAllClaimErrorCountAPI = {
  getAllClaimErrorCount: ({ claimId }: { claimId: any }) =>
    apiClient.post(URLS.getAllClaimErrorCount, {
      data: {
        claimId,
      },
    }),
};
export default getAllClaimErrorCountAPI;
